<template>
	<div>
		<v-chip v-bind="data.attrs" v-if="isMultipleSelection">
			<v-avatar left v-if="data.item && data.item.image" size="20">
				<v-img :src="data.item.image"></v-img>
			</v-avatar>
			{{ data.item.option }}
		</v-chip>
		<div v-else>
			<v-avatar left v-if="data.item && data.item.image" size="20">
				<v-img :src="data.item.image"></v-img>
			</v-avatar>
			{{ data.item.option }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'SearchFieldSelectedItem',
	props: {
		data: { type: Object },
		isMultipleSelection: { type: Boolean },
	},
};
</script>

<style scoped lang="scss"></style>
